export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.subNavigations = payload

  return newState;
};
